import { render, staticRenderFns } from "./chooseRoom.vue?vue&type=template&id=42e970ce&scoped=true"
import script from "./chooseRoom.vue?vue&type=script&lang=js"
export * from "./chooseRoom.vue?vue&type=script&lang=js"
import style0 from "./chooseRoom.vue?vue&type=style&index=0&id=42e970ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e970ce",
  null
  
)

export default component.exports